/* caribia-preis-hinweis.js: Countdown und Fenster fuer den Hinweis auf die Preiserhoehung (11.10.2026).
   Die Datei wird an bis zu drei Stellen eingebunden, laeuft aber nur einmal. */
(function () {
  if (window.cphGestartet) return;
  window.cphGestartet = true;

  function zwei(n) { return (n < 10 ? "0" : "") + n; }

  function start() {
    /* Fenster: nur das erste behalten und direkt in body haengen, damit es ueber allem liegt */
    var fenster = document.querySelectorAll("[data-cph-fenster]");
    for (var i = 1; i < fenster.length; i++) fenster[i].parentNode.removeChild(fenster[i]);
    var f = fenster[0];
    if (f && f.parentNode !== document.body) document.body.appendChild(f);
    var zuletzt = null;

    function auf() {
      if (!f) return;
      zuletzt = document.activeElement;
      f.hidden = false;
      document.documentElement.style.overflow = "hidden";
      var zu = f.querySelector("[data-cph-zu]");
      if (zu) zu.focus();
    }
    function schliessen() {
      if (!f || f.hidden) return;
      f.hidden = true;
      document.documentElement.style.overflow = "";
      if (zuletzt && zuletzt.focus) zuletzt.focus();
    }
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-cph-open]")) { e.preventDefault(); e.stopPropagation(); auf(); return; }
      if (e.target.closest("[data-cph-zu]") || e.target === f) schliessen();
    }, true);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") schliessen(); });

    /* Leiste: Nachrichten im Wechsel, alle 5 Sekunden; Pause bei Maus darueber und bei verstecktem Tab */
    document.querySelectorAll("[data-cph-ticker]").forEach(function (t) {
      var pause = false;
      t.addEventListener("mouseenter", function () { pause = true; });
      t.addEventListener("mouseleave", function () { pause = false; });
      setInterval(function () {
        var items = Array.prototype.filter.call(t.querySelectorAll(".cph-t-item"), function (el) { return !el.hidden; });
        if (pause || document.hidden || items.length < 2) return;
        var i = items.findIndex(function (el) { return el.classList.contains("an"); });
        var alt = items[i < 0 ? 0 : i], neu = items[(i + 1) % items.length];
        alt.classList.remove("an"); alt.classList.add("weg"); neu.classList.add("an");
        setTimeout(function () { alt.classList.add("still"); alt.classList.remove("weg"); void alt.offsetWidth; alt.classList.remove("still"); }, 560);
      }, 5000);
    });

    /* Countdown: jede Sekunde; ist das Datum erreicht, verschwindet der ganze Hinweis */
    var uhren = document.querySelectorAll("[data-cph-uhr]");
    if (!document.querySelector("[data-cph]")) return;
    var ende = Date.parse((uhren[0] && uhren[0].getAttribute("data-cph-ende")) || "2026-11-01T00:00:00+01:00");
    function ticken() {
      var rest = Math.floor((ende - Date.now()) / 1000);
      if (rest <= 0) {
        document.querySelectorAll("[data-cph]").forEach(function (el) { el.hidden = true; el.classList.remove("an"); });
        document.querySelectorAll("[data-cph-danach]").forEach(function (el) { el.hidden = false; el.classList.add("an"); });
        schliessen();
        return false;
      }
      var t = Math.floor(rest / 86400), h = Math.floor(rest % 86400 / 3600), m = Math.floor(rest % 3600 / 60), s = rest % 60;
      uhren.forEach(function (u) {
        var w = { t: String(t), h: zwei(h), m: zwei(m), s: zwei(s) };
        ["t", "h", "m", "s"].forEach(function (k) { var b = u.querySelector("[data-" + k + "]"); if (b) b.textContent = w[k]; });
        var tw = u.querySelector("[data-tw]"), tg = u.querySelector("[data-tage]");
        if (tw) tw.textContent = t === 1 ? "Tag" : "Tage";
        if (tg) tg.hidden = t === 0;
      });
      return true;
    }
    if (ticken()) var takt = setInterval(function () { if (!ticken()) clearInterval(takt); }, 1000);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
